export default __webpack_public_path__ + "static/media/BPT.6ba0bd9c.png";